var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSportLeftImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 187,
    height: 120,
    viewBox: "0 0 187 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.81 49.9404L93.4805 67.4604V102.49L123.81 120L154.15 102.49V67.4604L123.81 49.9404Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.79 47.9199L91.4502 65.4299V100.46L121.79 117.98L152.13 100.46V65.4299L121.79 47.9199Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.79 49.96L93.2197 66.45V99.44L121.79 115.94L150.36 99.44V66.45L121.79 49.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.33 73.4402C127.33 73.4702 127.33 73.4902 127.33 73.4902L126.45 74.3702C127.04 72.6102 125.28 68.7902 125.28 68.7902L126.03 67.9102C126.77 69.4002 127.22 71.0502 127.31 72.8002C127.31 72.8102 127.31 72.8201 127.31 72.8401C127.32 73.0401 127.33 73.2402 127.33 73.4402Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27 68.7901C125.27 68.7901 127.03 72.6101 126.44 74.3701L124.39 77.6001L121.45 76.4301L120.57 71.1401L122.62 67.6201L125.27 68.7901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.021 67.9105L125.271 68.7905L122.621 67.6205C122.621 67.6205 120.861 64.6805 119.101 64.0905L119.401 62.0405L119.491 61.8105C122.341 62.9705 124.671 65.1605 126.021 67.9105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.451 76.4307L124.391 77.6007C124.391 77.6007 124.391 80.8307 123.211 82.0007C123.171 82.0407 123.131 82.0707 123.091 82.1107C121.811 83.2007 118.521 83.4707 118.521 83.4707L117.931 79.9507L121.451 76.4307Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.44 74.3702L127.32 73.4902C127.32 77.1802 125.73 80.5002 123.21 82.8102L123.16 82.7602V82.2002L123.09 82.1102C123.13 82.0702 123.18 82.0402 123.21 82.0002C124.39 80.8302 124.39 77.6002 124.39 77.6002L126.44 74.3702Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.571 71.1399L121.451 76.4299L117.931 79.9499L112.931 78.4799L111.761 72.8999L115.581 69.6699L120.571 71.1399Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.491 61.8104L119.401 62.0404L119.101 64.0903C117.341 63.5003 114.701 65.0504 114.701 65.0504C112.941 63.6604 110.511 63.9604 110.511 63.9604L110.741 61.5004C111.991 61.0904 113.321 60.8604 114.701 60.8604C116.391 60.8604 118.011 61.2004 119.491 61.8104Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7 65.05C114.7 65.05 117.34 63.5 119.1 64.09C120.86 64.68 122.62 67.62 122.62 67.62L120.57 71.14L115.58 69.67L114.7 65.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.93 79.9505L118.52 83.4705C118.52 83.4705 116.46 85.2005 114.7 85.2205C112.35 85.5005 109.36 83.4705 109.36 83.4705C109.36 83.4705 108.53 82.0005 108.53 80.2405L112.93 78.4805L117.93 79.9505Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.21 82.8103C120.96 84.8603 117.98 86.1204 114.7 86.1204C114.69 86.1204 114.68 86.1204 114.66 86.1204C115.13 86.0604 115.26 85.9204 114.99 85.8204C114.11 85.5304 114.7 85.2204 114.7 85.2204C116.46 85.2004 118.52 83.4704 118.52 83.4704C118.52 83.4704 121.81 83.2004 123.09 82.1104L123.16 82.2003V82.7604L123.21 82.8103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7 65.0499L115.58 69.6699L111.76 72.8999L107.06 72.0199L106.48 67.5499C107.66 65.1299 110.5 63.9599 110.5 63.9599C110.5 63.9599 112.93 63.6599 114.7 65.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.761 72.9005L112.931 78.4805L108.531 80.2405C105.891 79.0605 105.011 76.1305 105.011 76.1305C105.601 72.9005 107.061 72.0205 107.061 72.0205L111.761 72.9005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.74 61.4902C110.73 61.5002 110.71 61.5002 110.7 61.5102L110.74 61.4902Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.53 80.2507C108.53 82.0107 109.36 83.4807 109.36 83.4807L107.34 83.7507H107.33C105.62 82.5207 104.24 80.8807 103.32 78.9707C103.45 79.1407 103.1 77.1807 103.03 76.1407H105.01C105.01 76.1307 105.89 79.0707 108.53 80.2507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7 85.2207C114.7 85.2207 114.11 85.5307 114.99 85.8207C115.27 85.9107 115.13 86.0507 114.66 86.1207C113.86 86.1207 113.07 86.0407 112.31 85.8907C112.29 85.8907 112.28 85.8807 112.26 85.8807C110.97 85.5807 109.3 84.9507 107.36 83.7607C107.35 83.7507 107.34 83.7507 107.34 83.7407L109.36 83.4707C109.36 83.4707 112.35 85.5007 114.7 85.2207Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.481 67.55C106.481 67.55 105.011 67.32 103.831 67.62C102.691 67.9 107.151 63.44 107.401 63.19C107.411 63.18 107.411 63.18 107.411 63.18L107.421 63.17L110.701 61.51C110.711 61.5 110.731 61.5 110.741 61.5L110.511 63.96C110.501 63.96 107.671 65.13 106.481 67.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.07 73.4904C102.07 69.2304 104.17 65.4804 107.39 63.1904C107.14 63.4404 102.68 67.9004 103.82 67.6204C105 67.3204 106.47 67.5504 106.47 67.5504L107.05 72.0204C107.05 72.0204 105.58 72.9004 105 76.1304H103.02C102.55 75.8604 102.14 74.3504 102.08 74.1404V74.1304C102.08 73.9204 102.07 73.7104 102.07 73.4904Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.311 72.8408C127.321 73.0408 127.331 73.2308 127.331 73.4408",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.74 61.5004C111.99 61.0904 113.32 60.8604 114.7 60.8604C116.4 60.8604 118.01 61.1904 119.49 61.8004C122.34 62.9704 124.67 65.1604 126.02 67.9104C126.76 69.4004 127.21 71.0504 127.3 72.8004",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.69 61.51C110.7 61.5 110.72 61.5 110.73 61.5",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42 63.1707C108.41 62.4707 109.52 61.9107 110.7 61.5107",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.09 74.1304C102.08 73.9204 102.07 73.7004 102.07 73.4904C102.07 69.2304 104.17 65.4804 107.39 63.1904",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.27 78.8599C102.59 77.4199 102.17 75.8199 102.09 74.1299",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.26 85.8807C110.45 85.5307 108.79 84.7907 107.36 83.7607",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.33 73.4902C127.33 77.1802 125.74 80.5002 123.22 82.8102C120.97 84.8602 117.99 86.1202 114.71 86.1202C114.7 86.1202 114.69 86.1202 114.67 86.1202C113.87 86.1202 113.08 86.0402 112.32 85.8902",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.7 65.05C114.7 65.05 117.34 63.5 119.1 64.09C120.86 64.68 122.62 67.62 122.62 67.62L120.57 71.14L115.58 69.67L114.7 65.05Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.501 63.9602C110.501 63.9602 107.661 65.1302 106.481 67.5502C106.481 67.5502 105.011 67.3202 103.831 67.6202C102.691 67.9002 107.151 63.4402 107.401 63.1902C107.411 63.1802 107.411 63.1802 107.411 63.1802L107.421 63.1702L110.701 61.5102L110.741 61.4902V61.5002L110.501 63.9602Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.311 72.8102C127.251 71.6902 127.011 69.4102 126.031 67.9102L126.021 67.9202L125.271 68.8002C125.271 68.8002 127.031 72.6201 126.441 74.3801L127.321 73.5002C127.321 73.5002 127.321 73.4801 127.321 73.4501C127.321 73.3601 127.321 73.1502 127.301 72.8502C127.311 72.8302 127.311 72.8202 127.311 72.8102Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.391 77.6007L121.451 76.4307L117.931 79.9507L118.521 83.4707C118.521 83.4707 121.811 83.2007 123.091 82.1107C123.131 82.0707 123.181 82.0407 123.211 82.0007C124.391 80.8307 124.391 77.6007 124.391 77.6007Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.931 78.4805L111.761 72.9005L107.061 72.0205C107.061 72.0205 105.591 72.9005 105.011 76.1305C105.011 76.1305 105.891 79.0705 108.531 80.2405L112.931 78.4805Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.36 83.76C107.35 83.75 107.34 83.75 107.34 83.74H107.33C105.62 82.51 104.24 80.87 103.32 78.96",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.26 85.8807C110.97 85.5807 109.3 84.9507 107.36 83.7607",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.311 85.8899C112.291 85.8899 112.281 85.8799 112.261 85.8799",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.33 83.7407L109.35 83.4707C109.35 83.4707 112.34 85.5007 114.69 85.2207C114.69 85.2207 114.1 85.5307 114.98 85.8207C115.26 85.9107 115.12 86.0507 114.65 86.1207C114.18 86.1807 113.37 86.1407 112.3 85.8907",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.5 63.9599C110.5 63.9599 112.93 63.6599 114.69 65.0499",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.761 72.8999L115.581 69.6699",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.06 72.0208L106.48 67.5508",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.931 79.9505L112.931 78.4805",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57 71.1406L121.45 76.4306",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.391 77.6001L126.441 74.3701",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27 68.7901L122.62 67.6201",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.101 64.09L119.401 62.04",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.52 83.4707C118.52 83.4707 116.46 85.2007 114.7 85.2207",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.36 83.4702C109.36 83.4702 108.53 82.0002 108.53 80.2402",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.09 74.1406C102.15 74.3506 102.55 75.8606 103.03 76.1306H105.01",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.09 74.1299V74.1399",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.08 74.1104C102.08 74.1104 102.08 74.1203 102.09 74.1303",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.32 78.9599C103.45 79.1299 103.1 77.1699 103.03 76.1299",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.271 78.8604C103.291 78.9104 103.301 78.9404 103.311 78.9604",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.24 78.7803C103.25 78.8203 103.26 78.8403 103.27 78.8703",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.16 82.76V82.21",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.47 86.5896C140.47 86.6196 140.47 86.6396 140.47 86.6396L139.59 87.5196C140.18 85.7596 138.42 81.9396 138.42 81.9396L139.17 81.0596C139.91 82.5496 140.36 84.1996 140.45 85.9496C140.45 85.9596 140.45 85.9696 140.45 85.9896C140.46 86.1896 140.47 86.3796 140.47 86.5896Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.42 81.9395C138.42 81.9395 140.18 85.7595 139.59 87.5195L137.54 90.7495L134.6 89.5795L133.72 84.2895L135.77 80.7695L138.42 81.9395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.17 81.06L138.42 81.94L135.77 80.77C135.77 80.77 134.01 77.83 132.25 77.24L132.55 75.19L132.64 74.96C135.49 76.12 137.82 78.31 139.17 81.06Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.6 89.5703L137.54 90.7403C137.54 90.7403 137.54 93.9703 136.36 95.1403C136.32 95.1803 136.28 95.2103 136.24 95.2503C134.96 96.3403 131.67 96.6103 131.67 96.6103L131.08 93.0903L134.6 89.5703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.589 87.5196L140.469 86.6396C140.469 90.3296 138.879 93.6496 136.359 95.9596L136.309 95.9097V95.3496L136.239 95.2597C136.279 95.2197 136.329 95.1897 136.359 95.1497C137.539 93.9797 137.539 90.7496 137.539 90.7496L139.589 87.5196Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72 84.2903L134.6 89.5703L131.08 93.0903L126.08 91.6303L124.91 86.0503L128.73 82.8203L133.72 84.2903Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.64 74.95L132.55 75.18L132.25 77.23C130.49 76.64 127.85 78.19 127.85 78.19C126.09 76.8 123.66 77.1 123.66 77.1L123.89 74.64C125.14 74.23 126.47 74 127.85 74C129.54 74.01 131.16 74.34 132.64 74.95Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25 77.2404C134.01 77.8304 135.77 80.7704 135.77 80.7704L133.72 84.2904L128.73 82.8204L127.85 78.2004C127.84 78.2004 130.48 76.6504 132.25 77.2404Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.08 93.0901L131.67 96.6101C131.67 96.6101 129.61 98.3401 127.85 98.3601C125.5 98.6401 122.51 96.6101 122.51 96.6101C122.51 96.6101 121.68 95.1401 121.68 93.3801L126.08 91.6201L131.08 93.0901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.13 98.9698C127.25 98.6798 127.84 98.3698 127.84 98.3698C129.6 98.3498 131.66 96.6198 131.66 96.6198C131.66 96.6198 134.95 96.3498 136.23 95.2598L136.3 95.3498V95.9098L136.35 95.9598C134.1 98.0098 131.12 99.2698 127.84 99.2698C127.83 99.2698 127.82 99.2698 127.8 99.2698C128.28 99.1998 128.41 99.0598 128.13 98.9698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65 77.1103C123.65 77.1103 126.08 76.8103 127.84 78.2003L128.72 82.8203L124.9 86.0503L120.2 85.1703L119.62 80.7003C120.81 78.2803 123.65 77.1103 123.65 77.1103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.91 86.0499L126.08 91.6299L121.68 93.3899C119.04 92.2099 118.16 89.2799 118.16 89.2799C118.75 86.0499 120.21 85.1699 120.21 85.1699L124.91 86.0499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88 74.6396C123.87 74.6496 123.85 74.6497 123.84 74.6597L123.88 74.6396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.68 93.3903C121.68 95.1503 122.51 96.6203 122.51 96.6203L120.49 96.8903H120.48C118.77 95.6603 117.39 94.0203 116.47 92.1103C116.6 92.2803 116.25 90.3203 116.18 89.2803H118.16C118.15 89.2803 119.03 92.2103 121.68 93.3903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.839 98.3701C127.839 98.3701 127.249 98.6801 128.129 98.9701C128.409 99.0601 128.269 99.2001 127.799 99.2701C126.999 99.2701 126.209 99.1901 125.449 99.0401C125.429 99.0401 125.419 99.0301 125.399 99.0301C124.109 98.7301 122.439 98.1001 120.499 96.9101C120.489 96.9001 120.479 96.9001 120.479 96.8901L122.499 96.6201C122.499 96.6201 125.489 98.6501 127.839 98.3701Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.63 80.7004C119.63 80.7004 118.16 80.4704 116.98 80.7704C115.84 81.0504 120.3 76.5904 120.55 76.3404C120.56 76.3304 120.56 76.3304 120.56 76.3304L120.57 76.3204L123.85 74.6604C123.86 74.6504 123.88 74.6504 123.89 74.6504L123.66 77.1104C123.65 77.1104 120.81 78.2804 119.63 80.7004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.22 86.6398C115.22 82.3798 117.32 78.6298 120.54 76.3398C120.29 76.5898 115.83 81.0498 116.97 80.7698C118.15 80.4698 119.62 80.6998 119.62 80.6998L120.2 85.1698C120.2 85.1698 118.73 86.0498 118.15 89.2798H116.17C115.7 89.0098 115.29 87.4998 115.23 87.2898V87.2798C115.22 87.0698 115.22 86.8498 115.22 86.6398Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45 85.9902C140.46 86.1902 140.47 86.3802 140.47 86.5902",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.88 74.64C125.13 74.23 126.46 74 127.84 74C129.54 74 131.15 74.33 132.63 74.94C135.48 76.11 137.81 78.3 139.16 81.05C139.9 82.54 140.35 84.19 140.44 85.94",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.84 74.6604C123.85 74.6504 123.87 74.6504 123.88 74.6504",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.56 76.3202C121.55 75.6202 122.66 75.0602 123.84 74.6602",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.24 87.2798C115.23 87.0698 115.22 86.8498 115.22 86.6398C115.22 82.3798 117.32 78.6298 120.54 76.3398",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.42 92.0103C115.74 90.5703 115.32 88.9703 115.24 87.2803",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41 99.0204C123.6 98.6704 121.94 97.9304 120.51 96.9004",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.47 86.6396C140.47 90.3296 138.88 93.6496 136.36 95.9596C134.11 98.0096 131.13 99.2696 127.85 99.2696C127.84 99.2696 127.83 99.2696 127.81 99.2696C127.01 99.2696 126.22 99.1896 125.46 99.0396",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.84 78.2004C127.84 78.2004 130.48 76.6504 132.24 77.2404C134 77.8304 135.76 80.7704 135.76 80.7704L133.71 84.2904L128.72 82.8204L127.84 78.2004Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65 77.1096C123.65 77.1096 120.81 78.2796 119.63 80.6996C119.63 80.6996 118.16 80.4696 116.98 80.7696C115.84 81.0496 120.3 76.5896 120.55 76.3396C120.56 76.3296 120.56 76.3297 120.56 76.3297L120.57 76.3196L123.85 74.6597L123.89 74.6396V74.6497L123.65 77.1096Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.45 85.9498C140.39 84.8298 140.15 82.5498 139.17 81.0498L139.16 81.0598L138.41 81.9398C138.41 81.9398 140.17 85.7598 139.58 87.5198L140.46 86.6398C140.46 86.6398 140.46 86.6198 140.46 86.5898C140.46 86.4998 140.46 86.2898 140.44 85.9898C140.45 85.9798 140.45 85.9598 140.45 85.9498Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.53 90.7403L134.59 89.5703L131.07 93.0903L131.66 96.6103C131.66 96.6103 134.95 96.3403 136.23 95.2503C136.27 95.2103 136.32 95.1803 136.35 95.1403C137.53 93.9803 137.53 90.7403 137.53 90.7403Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.08 91.6299L124.91 86.0499L120.21 85.1699C120.21 85.1699 118.74 86.0499 118.16 89.2799C118.16 89.2799 119.04 92.2199 121.68 93.3899L126.08 91.6299Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.5 96.9104C120.49 96.9004 120.48 96.9004 120.48 96.8904H120.47C118.76 95.6604 117.38 94.0204 116.46 92.1104",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.41 99.0204C124.12 98.7204 122.45 98.0904 120.51 96.9004",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.46 99.0403C125.44 99.0403 125.43 99.0303 125.41 99.0303",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.48 96.8901L122.5 96.6201C122.5 96.6201 125.49 98.6501 127.84 98.3701C127.84 98.3701 127.25 98.6801 128.13 98.9701C128.41 99.0601 128.27 99.2001 127.8 99.2701C127.33 99.3301 126.52 99.2901 125.45 99.0401",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.65 77.1103C123.65 77.1103 126.08 76.8103 127.84 78.2003",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.91 86.0503L128.73 82.8203",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.21 85.1702L119.63 80.7002",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.08 93.0899L126.08 91.6299",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72 84.29L134.6 89.57",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.53 90.7395L139.59 87.5195",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.42 81.9398L135.77 80.7598",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.25 77.2397L132.54 75.1797",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.66 96.6201C131.66 96.6201 129.6 98.3501 127.84 98.3701",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.5 96.6197C122.5 96.6197 121.67 95.1496 121.67 93.3896",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.24 87.2803C115.3 87.4903 115.7 89.0003 116.18 89.2703H118.16",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.23 87.2598C115.23 87.2598 115.23 87.2698 115.24 87.2798",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.46 92.1103C116.59 92.2803 116.24 90.3203 116.17 89.2803",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.42 92.0098C116.44 92.0598 116.45 92.0898 116.46 92.1098",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.39 91.9199C116.4 91.9599 116.41 91.9799 116.42 92.0099",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.31 95.9096V95.3496",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.75 71.4L134.03 70.08L130.83 72.4L130.94 68.45L127.74 66.13L131.53 65.01L132.76 61.25L134.99 64.51H138.94L136.54 67.65L137.75 71.4Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.37 95.8104L105.38 94.7504L102.81 96.6204L102.89 93.4404L100.33 91.5704L103.37 90.6704L104.36 87.6504L106.16 90.2704H109.33L107.4 92.7904L108.37 95.8104Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.86 88.46L144.51 87.98L143.35 88.82L143.39 87.39L142.24 86.55L143.61 86.15L144.05 84.79L144.86 85.97H146.29L145.42 87.1L145.86 88.46Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.22 115.12C145.17 115.06 140.03 109.25 120.46 109.25C100.52 109.25 94.83 113.98 94.78 114.03C94.87 113.95 94.91 113.91 94.91 113.91L95.61 108.13L88.75 107.91C89.93 106.7 97.01 100.66 120.46 100.66C130.54 100.66 138.75 102.05 144.86 104.81C149.74 107 151.65 109.35 152.13 110.01L145.04 109.56L145.11 114.97C145.11 114.97 145.14 115.03 145.22 115.12Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6302 61.9107C33.7933 61.9107 39.6002 56.1038 39.6002 48.9407C39.6002 41.7776 33.7933 35.9707 26.6302 35.9707C19.467 35.9707 13.6602 41.7776 13.6602 48.9407C13.6602 56.1038 19.467 61.9107 26.6302 61.9107Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3401 60.9302C30.5033 60.9302 36.3101 55.1234 36.3101 47.9602C36.3101 40.7971 30.5033 34.9902 23.3401 34.9902C16.177 34.9902 10.3701 40.7971 10.3701 47.9602C10.3701 55.1234 16.177 60.9302 23.3401 60.9302Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.21 41.1602L23.24 43.8402L28.3 41.2202L27.3 46.8302L31.36 50.8302L25.71 51.6202L23.16 56.7102L20.67 51.5902L15.04 50.7402L19.14 46.7802L18.21 41.1602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0555 103.091L48.998 106.011L51.918 111.068L56.9755 108.148L54.0555 103.091Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9728 80.8278L18.7363 79.168L17.0765 83.4045L21.313 85.0643L22.9728 80.8278Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.797 33.6559L155.561 31.9961L153.901 36.2326L158.137 37.8924L159.797 33.6559Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.14 116.18L166.46 112.17L165.82 119.1L172.14 116.18Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.67 76.5195C40.27 76.5195 39.88 76.3695 39.57 76.0695L36.73 73.2295C36.12 72.6195 36.12 71.6395 36.73 71.0395C37.34 70.4295 38.32 70.4295 38.92 71.0395L41.76 73.8795C42.37 74.4895 42.37 75.4695 41.76 76.0695C41.46 76.3695 41.06 76.5195 40.67 76.5195Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.78 37.5505C138.663 37.5505 140.19 36.0238 140.19 34.1405C140.19 32.2572 138.663 30.7305 136.78 30.7305C134.897 30.7305 133.37 32.2572 133.37 34.1405C133.37 36.0238 134.897 37.5505 136.78 37.5505Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.48 103.26C79.3194 103.26 80 102.579 80 101.74C80 100.9 79.3194 100.22 78.48 100.22C77.6405 100.22 76.96 100.9 76.96 101.74C76.96 102.579 77.6405 103.26 78.48 103.26Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.52 25.4796C185.453 25.4796 186.21 24.723 186.21 23.7896C186.21 22.8562 185.453 22.0996 184.52 22.0996C183.587 22.0996 182.83 22.8562 182.83 23.7896C182.83 24.723 183.587 25.4796 184.52 25.4796Z",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3301 9.33008L40.5301 21.4601",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3896 104.88L49.7796 88.4297",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.76953 12.4004L44.0695 28.8004",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8604 107.27L39.0204 99.1797",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.5 18.5002L120.06 5.16016",
    stroke: "#3BC9DB",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6098 96.2001C71.1658 96.2001 75.6698 91.6961 75.6698 86.1401C75.6698 80.5841 71.1658 76.0801 65.6098 76.0801C60.0538 76.0801 55.5498 80.5841 55.5498 86.1401C55.5498 91.6961 60.0538 96.2001 65.6098 96.2001Z",
    fill: "#1098AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2495 94.9403C71.8054 94.9403 76.3095 90.4363 76.3095 84.8803C76.3095 79.3243 71.8054 74.8203 66.2495 74.8203C60.6935 74.8203 56.1895 79.3243 56.1895 84.8803C56.1895 90.4363 60.6935 94.9403 66.2495 94.9403Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5 86.9399C65.23 89.2499 69.31 88.8999 71.62 86.1699",
    stroke: "#3BC9DB",
    strokeWidth: 0.622,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7296 82.0305C63.0775 82.0305 63.3596 81.7485 63.3596 81.4005C63.3596 81.0526 63.0775 80.7705 62.7296 80.7705C62.3817 80.7705 62.0996 81.0526 62.0996 81.4005C62.0996 81.7485 62.3817 82.0305 62.7296 82.0305Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6202 81.0705C70.9682 81.0705 71.2502 80.7885 71.2502 80.4406C71.2502 80.0926 70.9682 79.8105 70.6202 79.8105C70.2723 79.8105 69.9902 80.0926 69.9902 80.4406C69.9902 80.7885 70.2723 81.0705 70.6202 81.0705Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1798 77.9307L62.1498 79.8007L64.8098 79.2407L63.6398 81.6907L64.9898 84.0407L62.2998 83.6807L60.4798 85.7007L59.9898 83.0307L57.5098 81.9207L59.8998 80.6307L60.1798 77.9307Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0303 77.7504L69.7303 77.4903L71.0503 75.1104L72.1403 77.6003L74.8003 78.1204L72.7703 79.9203L73.1003 82.6104L70.7603 81.2403L68.3003 82.3904L68.8903 79.7403L67.0303 77.7504Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.12 77.8202C114.91 77.8202 116.73 15.2002 116.73 15.2002H51.5C51.5 15.2002 54.12 77.8202 84.12 77.8202Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.1005 76.8104C112.89 76.8104 114.71 14.1904 114.71 14.1904H49.4805C49.4805 14.1904 52.1005 76.8104 82.1005 76.8104Z",
    fill: "#3BC9DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3505 53.6207C110.991 53.6207 112.691 17.2207 112.691 17.2207H52.0205C52.0205 17.2207 54.4505 53.6207 82.3505 53.6207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.371 43.4009L111.011 37.6409L56.0605 35.3809C56.0605 35.3809 62.5405 40.6809 73.1405 42.3809C83.4405 44.0209 102.371 43.4009 102.371 43.4009Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.94 37.3309C104.94 37.3309 105.66 33.9309 104.22 33.7309C102.78 33.5309 102.37 34.5509 101.54 34.5509C100.71 34.5509 100.92 33.7309 100.92 33.7309C100.92 33.7309 98.7603 32.6009 93.0203 31.5709C84.0203 29.9609 79.7203 30.2309 79.7203 30.2309L75.0003 32.9009C75.0003 32.9009 64.3003 32.6909 56.0703 35.3709",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82 39.8007C107.82 39.8007 86.2102 39.1807 80.4502 36.5107",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23 41.4902C105.23 41.4902 86.3303 40.9402 79.6803 39.4402C73.0303 37.9402 71.0303 35.9902 71.0303 35.9902",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3408 35.4209C57.3408 35.4209 64.1808 39.8809 78.6008 41.4809C93.0108 43.0809 103.401 42.7009 103.401 42.7009",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7603 27.6307C85.7703 27.5707 85.8403 27.5707 85.8703 27.6207C85.9903 27.8507 86.3103 28.2207 87.0403 28.0707C87.5703 27.9607 87.9803 27.8107 88.2703 27.6807C88.4603 27.5907 88.6403 27.4807 88.8103 27.3507C89.0103 27.2107 89.4203 27.0107 89.7103 27.4507C90.1203 28.0707 88.4803 30.1307 86.8303 29.9207C85.4403 29.7407 85.6503 28.1707 85.7603 27.6307Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.1608 30.6706C87.1308 30.6706 87.1008 30.6706 87.0708 30.6706C87.0708 30.6706 85.2908 30.4906 85.2308 28.5606C85.1708 26.6306 85.7308 24.8506 88.1308 24.8506C89.9508 24.8506 90.5108 25.7606 90.5808 27.2006C90.6808 29.1206 89.1008 30.7306 87.1608 30.6706Z",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.941 37.3307C104.941 37.3307 81.2706 33.4207 74.8906 33.0107",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8905 30.9502L81.2705 33.6202",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3701 28.5501C90.3701 28.5501 91.3601 26.6201 92.1901 26.6201C92.7401 26.6201 95.8101 27.0501 97.8001 27.3301C98.8401 27.4801 99.6701 28.2501 99.9101 29.2701L100.94 33.7201",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0307 31.7701C94.0307 31.7701 94.2407 27.2401 92.1807 26.6201",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0303 29.2002C90.0303 29.2002 92.4403 29.9002 92.6203 31.4502",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8701 30.3207C84.8701 30.3207 85.1801 29.8107 85.6001 29.7607",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.3604 23.1602L72.8204 26.9602",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.9606 48.3203L71.1406 50.0903",
    stroke: "#3BC9DB",
    strokeWidth: 1.0112,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3502 74.8606C87.9338 74.8606 92.4602 70.3342 92.4602 64.7506C92.4602 59.167 87.9338 54.6406 82.3502 54.6406C76.7666 54.6406 72.2402 59.167 72.2402 64.7506C72.2402 70.3342 76.7666 74.8606 82.3502 74.8606Z",
    fill: "#15AABF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1794 71.8802C89.1551 71.8802 93.9994 67.036 93.9994 61.0602C93.9994 55.0845 89.1551 50.2402 83.1794 50.2402C77.2037 50.2402 72.3594 55.0845 72.3594 61.0602C72.3594 67.036 77.2037 71.8802 83.1794 71.8802Z",
    fill: "#0C8599"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.1794 70.3802C89.1551 70.3802 93.9994 65.536 93.9994 59.5602C93.9994 53.5845 89.1551 48.7402 83.1794 48.7402C77.2037 48.7402 72.3594 53.5845 72.3594 59.5602C72.3594 65.536 77.2037 70.3802 83.1794 70.3802Z",
    fill: "#22B8CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6986 50.1502L84.1986 62.2002L81.0586 59.2002L92.5586 47.1602L92.3586 50.5602L95.6986 50.1502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.009 57.1499L86.6589 60.2899L85.8389 56.0199L102.189 52.8799L100.049 55.5399L103.009 57.1499Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3991 53.1497L85.1491 51.9297L86.2491 53.7497L88.3391 53.3497L88.6091 55.4697L90.6791 55.9497L90.0691 57.9897L91.7591 59.2797L90.3691 60.8897L91.3991 62.7497L89.4691 63.6597L89.6491 65.7797L87.5191 65.8297L86.8191 67.8397L84.8591 67.0097L83.3991 68.5697L81.9391 67.0097L79.9791 67.8397L79.2791 65.8297L77.1491 65.7797L77.3291 63.6597L75.3991 62.7497L76.4291 60.8897L75.0391 59.2797L76.7391 57.9897L76.1191 55.9497L78.1891 55.4697L78.4591 53.3497L80.5491 53.7497L81.6491 51.9297L83.3991 53.1497Z",
    fill: "#99E9F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3993 65.8699C86.5031 65.8699 89.0193 63.3537 89.0193 60.2499C89.0193 57.146 86.5031 54.6299 83.3993 54.6299C80.2955 54.6299 77.7793 57.146 77.7793 60.2499C77.7793 63.3537 80.2955 65.8699 83.3993 65.8699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9245 61.7755H82.07V58.8354L82.1998 58.3084L81.8027 58.7666L81.0543 59.2554L80.6267 58.6292L82.4977 57.2317H83.101V61.7755H84.2235V62.6689H80.9245V61.7755Z",
    fill: "#0C8599"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSportLeftImage);
export default __webpack_public_path__ + "static/media/sportLeftImage.535d87cd2a9040e0e9ef69ffaadf7481.svg";
export { ForwardRef as ReactComponent };